import { render } from "./AppBaseError.vue?vue&type=template&id=45055258&scoped=true"
import script from "./AppBaseError.vue?vue&type=script&lang=js"
export * from "./AppBaseError.vue?vue&type=script&lang=js"

import "./AppBaseError.vue?vue&type=style&index=0&id=45055258&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45055258"]])

export default __exports__